import { CartItem as CartItemType } from '@/types/cart';

interface CartItemProps {
  item: CartItemType;
  maxQuantity: number;
  onUpdateQuantity: (id: string, change: number) => void;
}

export default function CartItem({ item, maxQuantity, onUpdateQuantity }: CartItemProps) {
  // 구매 제한에 도달했는지 확인
  const isMaxQuantityReached = item.quantity >= maxQuantity;

  return (
    <div className="border-b border-[#F2F4F6]">
      <div className="py-5 flex items-center justify-between">
        <div className="flex-1">
          <div className="space-y-[2px] mb-[5px]">
            <div className="text-lg font-semibold text-[#454545]">{item.name}</div>
            {item.option && <div className="text-sm font-medium text-[#868B93]">{item.option}</div>}
          </div>
          <div className="flex items-center gap-[2px]">
            <span className="text-lg font-semibold text-[#454545]">{item.price.toLocaleString()}</span>
            <span className="text-base font-semibold text-[#454545]">원</span>
          </div>
        </div>

        {/* 수량 조절 */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => onUpdateQuantity(item.id, -1)}
            className="w-[26px] h-[26px] bg-[#ECECEC] rounded-lg flex items-center justify-center"
          >
            {item.quantity === 1 ? (
              <img src="/icons/delete.svg" alt="삭제" width={10} height={10} />
            ) : (
              <span className="text-base font-medium text-[#1F1F1F]">-</span>
            )}
          </button>
          <span className="text-base font-semibold text-[#1F1F1F] w-4 text-center">{item.quantity}</span>
          <button
            onClick={() => onUpdateQuantity(item.id, 1)}
            disabled={isMaxQuantityReached}
            className={`w-[26px] h-[26px] rounded-lg flex items-center justify-center ${
              isMaxQuantityReached ? 'bg-[#F8F8F8] cursor-not-allowed' : 'bg-[#ECECEC]'
            }`}
          >
            <span className={`text-base font-medium ${isMaxQuantityReached ? 'text-[#C4C4C4]' : 'text-[#1F1F1F]'}`}>
              +
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
